import { useNavigate } from "react-router-dom";
import ListaAcoesRapidas, { TItemAcaoRapida } from "../../../../../components/ListaAcoesRapidas"
import ScreenBanner from "../../../../../components/ScreenBanner"
import AddIcon from '@mui/icons-material/Add';
import { Box, Container, Grid, IconButton, Paper, Stack, Typography } from "@mui/material";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import useSetParamsURL from "../../../../../lib/useSetParamsURL";
import BtnExportar from "../../../../../components/BtnExportar";
import { TableDataGridV2 } from "../../../../../components/TableDataGridV2";
import { processFilterValues } from "../../../../../components/TableDataGridV2/helpers";
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import PreFiltros from "../PreFiltrosListagem";
import { colunasAgronomos } from "../dataGridConfig";
import { useModalDetalheAgronomo } from "../ModalDetalheAgronomoContext";
import PermissionGuard, { usePermission } from "../../../../../components/PermissionGuard";

export default function Listagem() {

    const { openModal } = useModalDetalheAgronomo();
    const navigate = useNavigate();
    const { setParamsUrl, searchParams, setMultipleParamsUrl } = useSetParamsURL()

    const [preFilter, setPreFilter] = useState(true);
    const containerRef = useRef<HTMLDivElement>(null);

    const handleChangePreFilters = useCallback((value: TPreFilters) => {
        const filteredValues = processFilterValues(value, (key) => {
            filteredValues[key] = "";
        });

        setMultipleParamsUrl(filteredValues);
        if (containerRef.current) {
            containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [setMultipleParamsUrl])

    const handleClosePreFilter = useCallback(() => {
        setPreFilter(false)
    }, [])

    const listaAcoesRapidas: Array<TItemAcaoRapida> = [
        {
            label: `Incluir agronômo`,
            icon: <AddIcon color="primary" />,
            action: () => navigate('/cadastros/associado/listar-todos'),
            havePermission: usePermission("receituario.incluir-agronomo"),
        }
    ]

    const RenderListagem = useMemo(() => {
        const TableComponent = () => (
            <>
                {
                    preFilter &&
                    <Box
                        minHeight={250}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <PreFiltros
                            filtros={searchParams}
                            onSubmitFilters={(values) => {
                                handleChangePreFilters(values)
                                handleClosePreFilter()
                            }}
                        />
                    </Box>
                }
                {
                    !preFilter &&
                    <>
                        <BtnExportar boxProps={{ p: 2 }} />
                        <TableDataGridV2
                            urlParams
                            columns={colunasAgronomos}
                            url="/receituario-agronomico/pesquisar-agronomo"
                            queryKey="listar-todos-titulos-receber"
                            pagination="server"
                            queryParams={{ is_listagem: "true" }}
                            onRowDoubleClick={(id) => {
                                setParamsUrl(id.toString(), "detalhe-agronomo")
                                openModal(id.toString())
                            }}
                        />
                    </>
                }
            </>
        );

        return React.memo(TableComponent);
    }, [preFilter, openModal]);

    useEffect(() => {
        if (searchParams.size > 0) {
            setPreFilter(false)
        }
    }, [searchParams])

    return (
        <>
            <ScreenBanner title="Receituário Agronômico" />
            <PermissionGuard permissionId="receituario.listar-agronomos">
                <Container sx={{ mt: 3 }}>
                    <Typography textAlign="center" variant="h5">Agrônomos</Typography>
                    <Grid container spacing={2} mt={1}>
                        <Grid size={{xs: 12, md: 3}}>
                            <ListaAcoesRapidas
                                items={listaAcoesRapidas}
                                fullHeight={false}
                            />
                        </Grid>

                        <Grid size={{xs: 12, md: 9}}>
                            <Box component={Paper}>
                                <Box display="flex" justifyContent="space-between" alignItems="center" px={3} pt={2}>
                                    <Typography variant="h6">Lista de agrônomos</Typography>

                                    {
                                        !preFilter &&
                                        <Stack alignItems="flex-end" justifyContent="center" direction="row" gap={2}>
                                            <IconButton sx={{ p: 0 }} aria-label="delete" onClick={() => setPreFilter(true)}>
                                                <TuneOutlinedIcon />
                                            </IconButton>
                                        </Stack>
                                    }

                                </Box>
                                <RenderListagem />
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </PermissionGuard>
        </>
    )
}


export type TPreFilters = {
    [key: string]: any
}

